/**
 *  @shelf-version: 1.1.0
 */

import Modal from './ajax-modal';

export default Modal;
